import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';

import FooterTopBar from '../atoms/FooterTopBar';

interface FooterProps {
  taglineOnly?: boolean;
  className?: string;
}

interface StyledTaglineProps {
  $taglineOnly: boolean;
}

const StyledFooter = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  max-width: var(--max-width-m);
  z-index: 2;
`;

const StyledTagline = styled.p<StyledTaglineProps>`
  margin: 0;
  padding: var(--distance-s) 0;
  background-color: var(--color-background-accent);
  font-size: var(--font-size-s);
  line-height: var(--line-height-3xs);
  font-weight: var(--font-weight-bold);
  text-align: center;

  ${({ $taglineOnly }) =>
    $taglineOnly &&
    css`
      position: fixed;
      bottom: 0;
      width: 100%;
      max-width: var(--max-width-m);
    `}
`;

const Footer = ({ taglineOnly = false, className }: FooterProps) => {
  const { t, i18n } = useTranslation();
  return (
    <StyledFooter className={className}>
      {!taglineOnly && (
        <FooterTopBar
          links={[
            { label: t('footer.links.privacy.label'), to: t('footer.links.privacy.to') },
            { label: t('footer.links.legal.label'), to: t('footer.links.legal.to') },
          ]}
        />
      )}
      <StyledTagline $taglineOnly={taglineOnly}>{t('footer.tagline')}</StyledTagline>
    </StyledFooter>
  );
};

export default Footer;
